import WidgetGrid from "@components/widgets/Grid";
import { SearchFilterV4 } from "@/types/SearchFilter";
import SentimentDistributionWidget from "@components/widgets/SentimentDistribution";
import ReachOverTimeWidget from "@components/widgets/ReachOverTime";
import { differenceInDays } from "date-fns";
import { withDefaultDates } from "@/utils";
import MentionsOverTimeWidget from "@components/widgets/MentionsOverTime";
import ChannelTypesByMentionCountWidget from "@components/widgets/ChannelTypesByMentionCount";
import HighlightsWidget from "@components/widgets/Highlights";
import { Widget, WidgetContent } from "@components/ui/widget";

export default function TopWidgets({
  filters: _filters,
  searchUuid,
  orgUuid,
}: {
  filters: SearchFilterV4;

  searchUuid: Uuid;
  orgUuid: Uuid;
}) {
  // Helpers
  const filters = withDefaultDates(_filters);
  const diffInDays = differenceInDays(filters.end_date, filters.start_date);

  return (
    <WidgetGrid className="p-6 max-w-(--site-content-max-width)">
      <HighlightsWidget
        className="col-span-12"
        searchUuid={searchUuid}
        filters={filters}
      />

      <ReachOverTimeWidget
        orgUuid={orgUuid}
        filters={filters}
        searchUuid={searchUuid}
        diffInDays={diffInDays}
        className="col-span-12 @3xl/grid:col-span-6 @4xl/grid:col-span-8"
      />

      <SentimentDistributionWidget
        className="col-span-12 @3xl/grid:col-span-6 @4xl/grid:col-span-4"
        searchUuid={searchUuid}
        filters={filters}
      />

      <Widget className="col-span-12 py-0">
        <WidgetContent className="@5xl/grid:py-6 @5xl/grid:px-0">
          <WidgetGrid className="gap-px bg-border rounded-xl overflow-hidden px-0">
            <MentionsOverTimeWidget
              className="col-span-12 @5xl/grid:col-span-8 @5xl/grid:pr-1 @5xl/grid:py-0"
              searchUuid={searchUuid}
              diffInDays={diffInDays}
              orgUuid={orgUuid}
              filters={filters}
            />

            <ChannelTypesByMentionCountWidget
              className="col-span-12 @5xl/grid:col-span-4 @5xl/grid:pl-1 @5xl/grid:py-0"
              searchUuid={searchUuid}
              filters={filters}
            />
          </WidgetGrid>
        </WidgetContent>
      </Widget>
    </WidgetGrid>
  );
}
